module.exports = __webpack_public_path__ + "static/img/crx-logo.a89c06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crx-logo.png
// module id = GOoq
// module chunks = 1